import { orderBy } from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import IWGenericTable from 'shared/components/thunderbolt/IWGenericTable'
import IWLoading from 'shared/components/thunderbolt/IWLoading'
import IWTypography from 'shared/components/thunderbolt/IWTypography'
import { WizardStepProps } from 'shared/types'
import styled from 'styled-components'
import { lsErcotSubmissionPreviewTableColumns } from '../schemas'
import { LsErcotCsvRowItem } from '../types'

const StyledActionableSection = styled.div`
  display: flex;
  flex-direction: column;

  & > :first-child {
    margin-bottom: 0.25rem;
  }
`

type TableItem = LsErcotCsvRowItem

type StepState = {
  dayAheadDemandBids: LsErcotCsvRowItem[]
}

export type Props = WizardStepProps<StepState>

export default function LSDemandBidPreview({ state, onChange }: Props) {
  const { t } = useTranslation()
  const demandBids = state?.dayAheadDemandBids ?? []
  const [isLoading, setIsLoading] = useState(true)
  const [items, setItems] = useState<TableItem[]>([])
  const [updatedTableItems, setUpdatedTableItems] = useState<TableItem[]>([])

  const tableColumns = lsErcotSubmissionPreviewTableColumns

  const toTableItems = (bids: LsErcotCsvRowItem[]) => {
    const orderedItems = orderBy(bids || [], [
      ['market', 'brand', 'zone', 'location_name', 'location'],
    ])
    return orderedItems as TableItem[]
  }

  useEffect(() => {
    if (demandBids?.length) {
      setItems(toTableItems(demandBids))
      setIsLoading(false)
    }
  }, [demandBids])

  useEffect(() => {
    onChange(
      {
        dayAheadDemandBids: updatedTableItems as LsErcotCsvRowItem[],
      },
      true,
    )
  }, [updatedTableItems])

  return (
    <>
      <StyledActionableSection>
        <IWTypography
          size="lg"
          weight="medium"
          fontHue={{ color: 'grey', value: 900 }}
        >
          {t('loadScheduling.titles.submissionPreview')}
        </IWTypography>

        <IWTypography fontHue={{ color: 'grey', value: 500 }} size="sm">
          {t('loadScheduling.descriptions.submissionPreview')}
        </IWTypography>
      </StyledActionableSection>

      {isLoading && <IWLoading />}

      {Boolean(demandBids?.length) && !isLoading && (
        <IWGenericTable
          border
          items={items}
          columns={tableColumns}
          pinnedColumns={{ brand: 'left' }}
          showColumnSettings
          onTableItemsUpdated={(updatedItems) => {
            setUpdatedTableItems(updatedItems)
          }}
        />
      )}
    </>
  )
}
